import React from 'react'
import { useRouteMatch, Link , useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { ButtonMenu, ButtonMenuItem, Toggle, Text, NotificationDot } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import ToggleView, { ViewMode } from './ToggleView/ToggleView'

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;

  ${Text} {
    margin-left: 8px;
  }
`

const ViewControls = styled.div`
  flex-wrap: wrap;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    padding: 8px 0px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    justify-content: flex-start;
    width: auto;

    > div {
      padding: 0;
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    padding-left: 12px;
    padding-right: 12px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 16px;
  }
`

const PoolTabButtons = ({ stakedOnly, setStakedOnly, hasStakeInFinishedPools, viewMode }) => {
  const { url, isExact } = useRouteMatch()
  const { t } = useTranslation()
  const location = useLocation()


  const getActiveIndex = (pathname: string): number => {
    if (
      pathname.includes('/presale/all') ||
      pathname.includes('/presale/history')
    ) {
      return 0
    }
    return 1
  }


  const liveOrFinishedSwitch = (
    <Wrapper>
      <ButtonMenu activeIndex={getActiveIndex(location.pathname)}  scale="sm" variant="subtle">
        <ButtonMenuItem id="swap-nav-link"  to="/presale/all"  as={Link}>
          {t('Available')}
        </ButtonMenuItem>
        <NotificationDot show={hasStakeInFinishedPools}>
          <ButtonMenuItem id="swap-nav-link" to="/presale/finished"  as={Link} mt="4px">
            {t('Sold Out')}
          </ButtonMenuItem>
        </NotificationDot>
      </ButtonMenu>
    </Wrapper>
  )



  return (
    <ViewControls>
      {liveOrFinishedSwitch}
    </ViewControls>
  )
}

export default PoolTabButtons
